import request from '@/utils/request'
const preFixUrl = '/physicalExam'

// 体检预约
/**
 * 名单数据
 * @param {*} data
 * @returns
 */
export const getMemberUser = data => {
  return request({
    url: `${preFixUrl}/member/getMember`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**修改名单数据 */
export const updateMemberUser = data => {
  return request({
    url: `${preFixUrl}/member/edit`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}
// 体检预约
/**
 * 套餐列表
 * @param {*} data
 * @returns
 */
export const getList = data => {
  return request({
    url: `${preFixUrl}/combo/getList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}
/**
 * 套餐分类-列表
 * @param {*} data
 * @returns
 */
export const getTypeComboList = data => {
  return request({
    url: `${preFixUrl}/combo/getTypeComboList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 套餐项目查询
 * @param {*} id
 * @returns
 */
export const getComboNo = id => {
  return request({
    url: `${preFixUrl}/combo/getItemList/?comboNo=${id}`,
    method: 'get',
    headers: {
      ['Content-Type']: 'application/json'
    }
  })
}

/**
 * 获取体检预约登记记录列表
 * @param {*} data
 * @returns
 */
export const getReserveList = data => {
  return request({
    url: `${preFixUrl}/reserve/getList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 新增预约  体检
 * @param {*} data
 * @returns
 */
export const getReserveAdd = data => {
  return request({
    url: `${preFixUrl}/reserve/add`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 取消预约  体检
 * @param {*} data
 * @returns
 */
export const getReserveCancel = data => {
  return request({
    url: `${preFixUrl}/reserve/cancel2`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 查询套餐放号日历
 * @param {*} params
 * @returns
 */
export const getAllotComboCalendar = params => {
  return request({
    url: `${preFixUrl}/combo/getAllotComboCalendar`,
    method: 'get',
    headers: {
      ['Content-Type']: 'application/json'
    },
    params
  })
}
/**
 * 查询套餐放号日历
 * @param {*} params
 * @returns
 */
export const allotComboCalendar = data => {
  return request({
    url: `${preFixUrl}/combo/allotComboCalendar`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 查询套餐放号日历某一天的时间段
 * @param {*} params
 * @returns
 */
export const getAllotTimePeriod = data => {
  return request({
    url: `${preFixUrl}/combo/getAllotTimePeriod`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 获取注意事项
 * @param {*} params
 * @returns
 */
export const getPrecautions = params => {
  return request({
    url: `${preFixUrl}/content/getPrecautions`,
    method: 'get',
    headers: {
      ['Content-Type']: 'application/json'
    },
    params
  })
}

/**获取自选套餐状态*/
export const getComboTypeTipFlag = data => {
  return request({
    url: `${preFixUrl}/combo/getComboTypeTipFlag`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**获取自选套餐 */
export const getAdditionalComboList = data => {
  return request({
    url: `${preFixUrl}/combo/getAdditionalComboList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

//获取国籍列表
export const getCountryListRequest = data => {
  return request({
    url: `${preFixUrl}/member/getCountry/?countryCode=0`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}


